<template>
  <div id="app">
    <Header />
    <Wensenlijst v-bind:alleWensen="wensen" v-on:verwijder-wens="verwijderWens" />
    <MaakWens v-on:voeg-boek-toe = "voegBoekToe" />
  </div>
</template>

<script>
import Header from './components/layout/Header';
import Wensenlijst from './components/Wensenlijst';
import MaakWens from './components/MaakWens';

export default {
  name: 'app',
  components: {
    Wensenlijst,
    Header,
    MaakWens
  }, data() {
    return {
      wensen: [
        {
      titel: "De Bourgondie͏̈rs",
      cover: "https://s.s-bol.com/imgbase0/imagebase3/large/FC/7/6/2/7/9200000095737267.jpg",
      auteur: "Bart van Loo",
      uitgave: "2018-12",
      paginas: 560,
      taal: "Nederlands",
      ean: "9789403139005",
      prijs: 34.99,
      favoriet: true
   },
   {
   titel: "Summerproof met Sonja",
      cover: "https://s.s-bol.com/imgbase0/imagebase3/large/FC/0/7/3/5/9200000110145370.jpg",
      auteur: "Sonja Bakker",
      uitgave: "2019-05",
      paginas: 104,
      taal: "Nederlands",
      ean: "9789078211433",
      prijs: 15.95,
      favoriet: false
   },
   {
      titel: "Front-End Web Development a Complete Guide",
      cover: "https://s.s-bol.com/imgbase0/imagebase3/large/FC/7/3/1/7/9200000096507137.jpg",
      auteur: "Gerardus Blokdyk",
      uitgave: "2018-07",
      ean: "9780655315254",
      paginas: 274,
      taal: "Engels",
      prijs: 72.99,
      favoriet: true
   },
   {
      titel: "Huis vol leugens",
      cover: "https://s.s-bol.com/imgbase0/imagebase3/large/FC/6/4/9/0/9200000107050946.jpg",
      auteur: "Nicci French",
      uitgave: "2019-07",
      ean: "9789026343315",
      paginas: 400,
      taal: "Nederlands",
      prijs: 21.99,
      favoriet: false
   },
   
   {
      titel: "Dog Man",
      cover: "https://s.s-bol.com/imgbase0/imagebase3/large/FC/6/7/3/5/9200000091585376.jpg",
      auteur: "Dav Pilkey",
      uitgave: "2018-06",
      paginas: 231,
      taal: "Nederlands",
      ean: "9789492899019",
      prijs: 14.99,
      favoriet: false
   }
      ]
    }
  },
  methods: {
    verwijderWens(id) {
      this.wensen = this.wensen.filter(wens => wens.ean !== id);
    },
    voegBoekToe(nieuwBoek) {
      this.wensen = [...this.wensen, nieuwBoek];
    }
  }
}
</script>

<style>

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.4;
}

</style>
